import { ReduxState } from 'ducks';
import Head from 'next/head';
import { useSelector } from 'react-redux';
import { useUrlQueryDisplayState } from './useUrlQueryDisplayState';

export const MapHead = () => {
  const digitalMap = useSelector((state: ReduxState) => state.universal.digitalMap.map);

  const { activePinKey, pinInfoDisplayStatus } = useUrlQueryDisplayState();

  const activePin = digitalMap?.pins.find(
    (pin) => pin.key === activePinKey && pinInfoDisplayStatus !== 'HIDDEN'
  );

  const title = activePin ? activePin.title : digitalMap?.seo_params?.title;
  const metaDescription = activePin
    ? activePin.description
    : digitalMap?.seo_params?.meta_description;
  const imageUrl = activePin
    ? activePin.media_items.find((mediaItem) => mediaItem.type === 'IMAGE')?.url
    : digitalMap?.seo_params?.thumbnail_url;

  const pwaEnabled = digitalMap?.pwa_settings?.enable_pwa_installation;

  return (
    <Head>
      {title && <title>{title}</title>}
      {metaDescription && <meta name="description" content={metaDescription} />}
      {title && <meta property="og:title" content={title} />}
      <meta property="og:type" content="website" />
      {imageUrl && <meta property="og:image" content={imageUrl} />}

      {/* PWA */}
      {pwaEnabled && digitalMap?.pwa_settings?.theme_color && (
        <meta name="theme-color" content={digitalMap?.pwa_settings?.theme_color} />
      )}
      {pwaEnabled && <meta name="apple-mobile-web-app-capable" content="yes" />}
      {pwaEnabled && <meta name="apple-mobile-web-app-status-bar-style" content="default" />}
      {pwaEnabled && digitalMap?.pwa_settings?.title && (
        <meta name="apple-mobile-web-app-title" content={digitalMap?.pwa_settings?.title} />
      )}
      {pwaEnabled && digitalMap?.pwa_settings?.icon_url_180 && (
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href={digitalMap?.pwa_settings?.icon_url_180}
        />
      )}
      {pwaEnabled && digitalMap?.pwa_settings?.icon_url_192 && (
        <link
          rel="apple-touch-icon"
          sizes="192x192"
          href={digitalMap?.pwa_settings?.icon_url_192}
        />
      )}
      {pwaEnabled && digitalMap?.pwa_settings?.icon_url_512 && (
        <link
          rel="apple-touch-icon"
          sizes="512x512"
          href={digitalMap?.pwa_settings?.icon_url_512}
        />
      )}
    </Head>
  );
};
